import { IStoreType } from '../interfaces';

export const ShopifyStoreConstant :IStoreType = { id: 1, storeType: 'Shopify' };
export const WoocommerceStoreConstant :IStoreType = {
  id: 2,
  storeType: 'Woocommerce',
};
export const AmazonStoreConstant :IStoreType = { id: 3, storeType: 'Amazon' };
export const Api2CartStoreConstant :IStoreType = {
  id: 4,
  storeType: 'Api2Cart',
};
export const HubSpotStoreConstant :IStoreType = { id: 5, storeType: 'HubSpot' };
export const EcartStoreConstant :IStoreType = { id: 6, storeType: 'Ecart Api' };
export const TrackstarStoreConstant :IStoreType = {
  id: 7,
  storeType: 'Trackstar',
};

export const StoreTypeConstant = {
  SHOPIFY: ShopifyStoreConstant.id,
  WOOCOMMERCE: WoocommerceStoreConstant.id,
  AMAZON: AmazonStoreConstant.id,
  API2CART: Api2CartStoreConstant.id,
  HUBSPOT: HubSpotStoreConstant.id,
  ECARTAPI: EcartStoreConstant.id,
  TRACKSTAR: TrackstarStoreConstant.id,
};

export const StoreTypesListConstant :IStoreType[] = [
  ShopifyStoreConstant,
  WoocommerceStoreConstant,
  AmazonStoreConstant,
  Api2CartStoreConstant,
  HubSpotStoreConstant,
  EcartStoreConstant,
  TrackstarStoreConstant,
];
